export default "__VITE_ASSET__ChmPDkqi__"